import Template from '@/common/template'

import Index from "@/views/index/index";
import AdminManager from '@/views/admin/manager/manager'
import AdminRole from '@/views/admin/role/role'
import GuestSource from '@/views/guest/source/source'
import GuestDeposit from '@/views/guest/deposit/deposit'
import OrderEdit from '@/views/order/edit/edit'
import OrderRepay from '@/views/order/repay/repay'
import OrderThrow from '@/views/order/throw/throw'
import CardList from '@/views/card/card-list/card-list'
import CardType from '@/views/card/card-type/card-type'
import CardSeller from '@/views/card/seller/seller'
import CardUser from '@/views/card/card-user/card-user'
import Statistic from '@/views/statistic/statistic'
import Vehicle from '@/views/vehicle/vehicle'
import Goods from '@/views/goods/goods'
import Area from '@/views/area/area'
import Log from '@/views/log/log'

export const routes = [{
    path: '/index',
    component: Index,
    meta: {
        title: '首页',
        icon: 'home',
        breadcrumb: ['首页'],
        routeName: '/index',
        cachedName: 'index'
    }
},
{
    path: '/admin',
    component: Template,
    meta: {
        title: 'Admin',
        icon: 'lock',
        breadcrumb: ['Admin'],
        routeName: '/admin',
        cachedName: 'admin'
    },
    children: [{
        path: 'manager',
        component: AdminManager,
        meta: {
            title: '账号管理',
            icon: 'team',
            breadcrumb: ['Admin', '账号管理'],
            routeName: '/admin/manager',
            cachedName: 'admin_manager'
        }
    },
    {
        path: 'role',
        component: AdminRole,
        meta: {
            title: '角色管理',
            icon: 'block',
            breadcrumb: ['Admin', '角色管理'],
            routeName: '/admin/role',
            cachedName: 'admin_role'
        }
    }]
},
{
    path: '/guest',
    component: Template,
    meta: {
        title: '客户管理',
        icon: 'contacts',
        breadcrumb: ['客户管理'],
        routeName: '/guest',
        cachedName: 'guest'
    },
    children: [{
        path: 'source',
        component: GuestSource,
        meta: {
            title: '客户资料',
            icon: 'file-text',
            breadcrumb: ['客户管理', '客户资料'],
            routeName: '/guest/source',
            cachedName: 'guest_source'
        }
    },
        // {
        //     path: 'deposit',
        //     component: GuestDeposit,
        //     meta: {
        //         title: '客户押金',
        //         icon: 'dollar',
        //         breadcrumb: ['客户管理', '客户押金'],
        //         routeName: '/guest/deposit',
        //         cachedName: 'guest_deposit'
        //     }
        // },
    ]
},
{
    path: '/order',
    component: Template,
    meta: {
        title: '订单管理',
        icon: 'container',
        breadcrumb: ['订单管理'],
        routeName: '/order',
        cachedName: 'order'
    },
    children: [{
        path: 'edit',
        component: OrderEdit,
        meta: {
            title: '编辑订单',
            icon: 'file-search',
            breadcrumb: ['订单管理', '编辑订单'],
            routeName: '/order/edit',
            cachedName: 'order_edit'
        }
    },
    {
        path: 'throw',
        component: OrderThrow,
        meta: {
            title: '作废订单',
            icon: 'exception',
            breadcrumb: ['订单管理', '作废订单'],
            routeName: '/order/throw',
            cachedName: 'order_throw'
        }
    },
    {
        path: 'repay',
        component: OrderRepay,
        meta: {
            title: '订单销账',
            icon: 'audit',
            breadcrumb: ['订单管理', '订单销账'],
            routeName: '/order/repay',
            cachedName: 'order_repay'
        }
    }]
},
{
    path: '/card',
    component: Template,
    meta: {
        title: '营销管理',
        icon: 'shop',
        breadcrumb: ['营销管理'],
        routeName: '/card',
        cachedName: 'card'
    },
    children: [{
        path: 'card-list',
        component: CardList,
        meta: {
            title: '卡列表',
            icon: 'credit-card',
            breadcrumb: ['营销管理', '卡列表'],
            routeName: '/card/card-list',
            cachedName: 'card_card-list'
        }
    },
    {
        path: 'card-type',
        component: CardType,
        meta: {
            title: '卡类型',
            icon: 'control',
            breadcrumb: ['营销管理', '卡类型'],
            routeName: '/card/card-type',
            cachedName: 'card_card-type'
        }
    },
    {
        path: 'seller',
        component: CardSeller,
        meta: {
            title: '经销商管理',
            icon: 'transaction',
            breadcrumb: ['营销管理', '经销商管理'],
            routeName: '/card/seller',
            cachedName: 'card_seller'
        }
    },
    {
        path: 'card-user',
        component: CardUser,
        meta: {
            title: '注册用户',
            icon: 'crown',
            breadcrumb: ['营销管理', '注册用户'],
            routeName: '/card/card-user',
            cachedName: 'card_card-user'
        }
    }]
},
{
    path: '/statistic',
    component: Statistic,
    meta: {
        title: '统计数据',
        icon: 'line-chart',
        breadcrumb: ['统计数据'],
        routeName: '/statistic',
        cachedName: 'statistic'
    }
},
{
    path: '/vehicle',
    component: Vehicle,
    meta: {
        title: '车辆管理',
        icon: 'car',
        breadcrumb: ['车辆管理'],
        routeName: '/vehicle',
        cachedName: 'vehicle'
    }
},
{
    path: '/area',
    component: Area,
    meta: {
        title: '区域管理',
        icon: 'dot-chart',
        breadcrumb: ['区域管理'],
        routeName: '/area',
        cachedName: 'area'
    }
},
{
    path: '/goods',
    component: Goods,
    meta: {
        title: '商品信息',
        icon: 'shopping',
        breadcrumb: ['商品信息'],
        routeName: '/goods',
        cachedName: 'goods'
    }
},
{
    path: '/log',
    component: Log,
    meta: {
        title: '日志信息',
        icon: 'calendar',
        breadcrumb: ['日志信息'],
        routeName: '/log',
        cachedName: 'log'
    }
}]
